import { TREATMENT_INSTANCE_SORTING_SET } from '../../../actions/constants/types';

const initialState = {
  orderBy: 'RAG',
  orderDir: 'desc',
};

function treatmentInstanceSorting(state = initialState, action) {
  switch (action.type) {
    case TREATMENT_INSTANCE_SORTING_SET:
      return { ...action.sorting };
    default:
      return state;
  }
}

export default treatmentInstanceSorting;
